/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_COSTUME_TYPE } from "../../costumePageService/graphql/getCostumeFeatures.query";
import { formatCostumeTypeData } from "../../shared/formatCostumeType";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCostumeTypePreviewMethods extends IPluginMethodMap {
  getCostumeTypePreview(args: any): Promise<any>;
}

export class GetCostumeTypePreviewService implements IAgentPlugin {
  readonly methods: IGetCostumeTypePreviewMethods;

  constructor() {
    this.methods = {
      getCostumeTypePreview: this.getCostumeTypePreview.bind(this),
    };
  }

  async getCostumeTypePreview(costumeTypeId: string) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (!client) {
        throw Error("GraphQL client not found.");
      }

      const res = await client.query({
        query: GET_COSTUME_TYPE,
        variables: {
          filter: {
            _id: costumeTypeId,
          },
        },
        fetchPolicy: "network-only",
      });

      if (res?.data?.getCostumeType) {
        return formatCostumeTypeData(res.data.getCostumeType);
      }

      throw Error("Costume type not found.");
    } catch (err: any) {
      const displayMessage =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);

      if (displayMessage?.extensions?.display_message) {
        throw Error(displayMessage.extensions.display_message);
      }

      throw err;
    }
  }
}
